<template>
	<div>
		<div class="bar_echarts" id="bar_echarts"></div>
	</div>
</template>

<script>
export default {
	name: '',
	props: ['echartsData', 'currentYear'],
	data() {
		return {
			detailsList: [], // 接口返回的数据
			currentYearNow: this.currentYear,
			_isMounted: false,
		};
	},
	watch: {
		currentYear: {
			immediate: true,
			handler(to) {
				if (!this._isMounted) return; // 防止初始化时提前跑
				this.currentYearNow = to;
				this.$nextTick(() => {
					this.getEcharts(to);
				});
			},
		},
	},
	mounted() {
		this._isMounted = true; // 标记已挂载
		this.getEcharts(this.currentYearNow);
	},
	methods: {
		getEcharts(currentYearNow) {
			var chartDom = document.getElementById('bar_echarts');
			var myChart = this.$echarts.init(chartDom);
			let _this = this;
			$.ajax({
				url: `https://www.drcnet.com.cn/reportapi/CommonController/common/docCountByTagAndYear?uid=A62304&year=${currentYearNow}&docIndexTypeId=46`,
				type: 'get',
				dataType: 'json',
				success: function(data) {
					if (data.data) {
						const names = data.data.map((item) => item.name);
						const values = data.data.map((item) => item.value);
						let option = {
							// title: {
							// 	text: `${this.currentYearNow} 各行业数据统计`,
							// 	left: 'center',
							// 	textStyle: {
							// 		fontSize: 16,
							// 		color: '#333',
							// 	},
							// },
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow', // 鼠标指向时显示阴影
								},
							},
							grid: {
								left: '0',
								right: '0',
								bottom: '5%',
								top: '10%',
								containLabel: true,
							},
							xAxis: {
								type: 'category',
								data: names,
								axisTick: {
									show: false,
								},
								axisLine: {
									show: true,
									lineStyle: {
										color: '#DDE1E3',
									},
								},
								axisLabel: {
									interval: 0, // 强制显示所有标签
									textStyle: {
										color: '#666666',
									},
								},
							},
							yAxis: {
								type: 'value',
								axisTick: {
									show: false,
								},
								axisLine: {
									show: true,
									lineStyle: {
										color: '#DDE1E3',
									},
								},
								axisLabel: {
									textStyle: {
										color: '#666666',
									},
								},
								splitLine: {
									lineStyle: {
										color: '#DDE1E3',
										// type: 'dashed',
									},
								},
							},
							series: [
								{
									name: '数量',
									type: 'bar',
									barWidth: '50%',
									data: values,
									itemStyle: {
										color: '#43aa4e', // 固定柱子颜色
										// barBorderRadius: [4, 4, 0, 0], // 圆角柱子
									},
									label: {
										show: false,
										position: 'top',
										color: '#333',
										fontSize: 12,
									},
								},
							],
						};

						myChart.setOption(option);
						myChart.on('click', function(param) {
							const url = `#/column?id=247&name=五周年专题&uid=A62304&showType=1-1&newAreaName=${param.name}`;
							window.open(url, '_blank'); // _blank 表示新开标签页
						});
					}
				},
				error: function(xhr, status, error) {
					console.error('请求失败:', status, error);
				},
			});
			// 窗口大小变化时自适应
			window.addEventListener('resize', () => {
				myChart.resize();
			});
		},
	},
};
</script>

<style lang="less" scoped>
.bar_echarts {
	width: 100%;
	height: 340px;
	padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/view/fiveth/components/bar/index.vue